import type { DeliverableStep, LoeSpan, Period } from "./types";
import { periodIndexOf } from "./calendar";

/** Periods an item dated start..end touches, clamped to the calendar (rule 20's spread for indirects). */
export function spanPeriods(periods: Period[], start: string, end: string): { from: number; to: number } | null {
  if (!periods.length || end < start) return null;
  const a = periodIndexOf(periods, start);
  const b = periodIndexOf(periods, end);
  const from = a === "before" ? 0 : a === "after" ? periods.length : a;
  const to = b === "after" ? periods.length - 1 : b === "before" ? -1 : b;
  return to >= from ? { from, to } : null;
}

/**
 * An LOE deliverable as engine steps: one step per period of its span, each adding an equal share, planned on that
 * period's cutoff and earned on it once the period has elapsed (periods up to and including the current one).
 * With these steps the normal deliverable maths (bookings, period close, roll-ups, reports) applies unchanged.
 */
export function loeSteps(span: LoeSpan, periods: Period[], currentIdx: number): DeliverableStep[] {
  const r = spanPeriods(periods, span.start, span.end);
  if (!r) return [];
  const n = r.to - r.from + 1;
  const out: DeliverableStep[] = [];
  for (let k = 0; k < n; k++) {
    const p = periods[r.from + k];
    out.push({ milestone: `P${p.number}`, cum: k === n - 1 ? 1 : (k + 1) / n, planned: p.cutoff, forecast: null, earned: r.from + k <= currentIdx ? p.cutoff : null, codes: {} });
  }
  return out;
}
